import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";

import {
  collection,
  getDocs,
  db,
  query,
  limit,
  orderBy,} from '../../FirebaseInit'


const initialState = {
  trailer: [],
  isLoading: false,
  isError: false,
  error:''
};

export const topTrailer = createAsyncThunk('topTrailer',
  (data) => {
    return new Promise(async(res,rej) => {
      try {
        const trailer = query(collection(db, 'movie'), orderBy("trailer"),orderBy("rating",'desc'),orderBy('createdAt','desc'), limit(10))

        const querySnapShot = await getDocs(trailer)
        const list = [];
        querySnapShot.forEach(doc => {
          list.push({...doc.data()})
        })
        console.log(list);
       res(list)
      } catch (e) {
        console.log(e.message);
        rej(e.message)
    }
  })
  });



export const topTrailerSlice = createSlice({
  name: "topTrailer",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(topTrailer.pending, (state, _) => {
      state.isLoading = true;
      state.isError = false;
      state.error = '';
    });
    builder.addCase(topTrailer.fulfilled, (state, {payload}) => {
      state.trailer = payload;
      state.isLoading = false;
      state.isError = false;
      state.error = "";
    });
    builder.addCase(topTrailer.rejected, (state, {payload}) => {
      state.isLoading = false;
        state.isError = true;
        state.error = payload;
    })
  
  }
})
  
export const topTrailerReducer = topTrailerSlice.reducer;